import { useQuery } from '@tanstack/react-query';
import { MdError } from 'react-icons/md';
import { toast } from 'react-toastify';
import ReactIcon from '../components/ReactIcon';
import { parkTicketEnumKey, surfTicketEnumKey } from '../consts/typeListConst';
import { DateUtils } from '../helpers/dateUtils';
import { GetItemsShop } from '../services/salesShopItems.service';
import { useShoppingCartStore } from '../store/shoppingCart/shoppingCartStore';

type PropsGetShopItemsServices = {
    Date?: Date;
    ProductId?: number;
    ProductTypeId?: number;
    ProductWaveSide?: 'Left' | 'Right';
};

const currentDate = new Date();

export const useGetShopItemsServices = ({
    Date,
    ProductId,
    ProductWaveSide,
    ProductTypeId,
}: PropsGetShopItemsServices) => {
    const shoppingCartStore = useShoppingCartStore();
    const { isPending, data } = useQuery({
        queryKey: [
            'shopServices',
            Date,
            ProductId,
            ProductWaveSide,
            ProductTypeId,
        ],
        queryFn: async () => {
            const dateFormatted = DateUtils.formatToInitalYear(
                Date || currentDate
            );
            const response = await GetItemsShop({
                Date: dateFormatted,
                ProductId,
                ProductWaveSide,
                ProductTypeId,
            });

            if (
                shoppingCartStore.cartValues &&
                shoppingCartStore.cartValues.length > 0
            ) {
                response.forEach(item => {
                    if (shoppingCartStore.isPaymentLinkCart) return;
                    const target = shoppingCartStore.cartValues!.find(
                        d => d.id === item.id.toString()
                    );
                    if (!target) return;
                    shoppingCartStore.updateItemPrice(item.id.toString(), item.value, dateFormatted);
                });
            }

            const result = response.filter(
                ({ productType }) =>
                    productType.category.enumKey !== parkTicketEnumKey &&
                    productType.category.enumKey !== surfTicketEnumKey
            );

            return result;
        },
        throwOnError: () => {
            toast.error(() => 'Erro ao atualizar os serviços disponíveis', {
                toastId: 4,
                style: {
                    fontSize: '1rem',
                    fontWeight: '400',
                },
                position: 'top-right',
                autoClose: 5000,
                icon: (
                    <ReactIcon
                        Icon={MdError}
                        size={'1.5rem'}
                        fill="#e40505"
                        color="white"
                    />
                ),
            });
            return false;
        },
    });

    return {
        isPending,
        data,
    };
};
